export const CLAIMS_REPORTING_API_URLS = {
  FETCH_CLAIMS_REPORTING: '/claims-reporting',
  FETCH_CLAIMS_REPORTING_CATEGORIES: '/fetch-claims-reporting-categories',
  SAVE_CLAIMS_REPORTING: '/claims-reporting/save-claims-report',
  FETCH_CLAIMS_REPORTING_LIST: '/claims-reporting/saved-reports/user',
  REMOVE_CLAIMS_REPORT: (reportId: string) => `/claims-reporting/saved-reports/${reportId}`,
  GENERATE_CONVERSATION: '/claims-reporting/start-conversation',
  GENERATE_PREVIEW_REPORT: '/claims-reporting-job/conversations/message',
  FETCH_SINGLE_CLAIMS_REPORT: '/claims-reporting/saved-reports/user/report',
  FETCH_CLAIMS_REPORT_PREVIEW_BY_JOB_ID: (jobid: string) => `/job-status/result/${jobid}`,
  FETCH_CLAIMS_REPORTING_BY_ATTACHMENT_ID: `/claims-reporting-job/attachmentId/queryResult`,
  UPDATE_CLAIMS_REPORT_PARAMETERS: '/claims-reporting/save-claims-report',
};
export default CLAIMS_REPORTING_API_URLS;